import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { Schedule } from '../schedule.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class SchedulesResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  get(schedule_id: string, params?: QueryParams): Observable<Schedule> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((store_account_id) =>
        this.http.get<Schedule>(`${this.apiRoot}/${store_account_id}/api/schedules/${schedule_id}`, { params }),
      ),
    );
  }

  save(body: Partial<Schedule>, params?: QueryParams): Observable<Schedule> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.post<Schedule>(`${this.apiRoot}/${account_id}/api/schedules`, body, { params }),
      ),
    );
  }

  update(schedule_id: number, body: Partial<Schedule>, params?: QueryParams): Observable<Schedule> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.put<Schedule>(`${this.apiRoot}/${account_id}/api/schedules/${schedule_id}`, body, { params }),
      ),
    );
  }

  remove(schedule_id: number, params?: QueryParams): Observable<any> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.delete<Schedule>(`${this.apiRoot}/${account_id}/api/schedules/${schedule_id}`, { params }),
      ),
    );
  }

  query(params?: QueryParams): Observable<Schedule[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<Schedule[]>(`${this.apiRoot}/${account_id}/api/schedules`, { params })),
    );
  }

  search(params?: QueryParams): Observable<Schedule[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Schedule[]>(`${this.apiRoot}/${account_id}/api/schedules/search`, { params }),
      ),
    );
  }

  run(schedule_id: number, body: Partial<Schedule>, params?: QueryParams): Observable<Schedule> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.post<Schedule>(`${this.apiRoot}/${account_id}/api/schedules/${schedule_id}/run`, body, {
          params,
        }),
      ),
    );
  }

  clone(schedule_id: number, body: Partial<Schedule>, params?: QueryParams): Observable<Schedule> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.post<Schedule>(`${this.apiRoot}/${account_id}/api/schedules/${schedule_id}/clone`, body, {
          params,
        }),
      ),
    );
  }
}

((window as any).xplenty as angular.IModule).service('Schedule', downgradeInjectable(SchedulesResource));
